import { HumanReadableFilters } from './HumanReadableFilters'
import React, { useContext } from 'react'
import { Trans } from '@lingui/macro'
import IconPeople from '../../../components/common/icon/IconPeople'
import { Link } from 'react-router-dom'
import './CampaignOverview.less'
import { CampaignAnalyticHighlights } from './CampaignAnalyticHighlight'
import { CampaignActions } from '../campaign-actions/CampaignActions'
import CampaignReadinessHero from './CampaignReadinessHero'
import { ManageCampaignContext } from '../ManageCampaignPage'
import { ButtonLight } from 'front-end/src/components'

export const CampaignOverview = () => {
  const { campaign, refetchCampaign } = useContext(ManageCampaignContext)

  React.useEffect(() => {
    // when this component mounts, we should update data of campaign
    refetchCampaign()
  }, [])

  return (
    <div className="CampaignOverview">
      <CampaignReadinessHero />

      <CampaignAnalyticHighlights
        // @ts-expect-error 9/11/2020
        analyticEventsCount={campaign.scheduledActionsCountUntilNow}
        // @ts-expect-error 9/11/2020
        audienceCompletedCount={campaign.audienceCompletedCount}
        // @ts-expect-error 9/11/2020
        audienceJoinEventsCount={campaign.audienceJoinEventsCount}
        // @ts-expect-error 9/11/2020
        immediateUsersCount={campaign.immediateUsersCount}
      />

      <section>
        <Link
          to={`${location.pathname}/audience`}
          className="CampaignOverview__audience"
        >
          {campaign.filters.length === 0 && (
            <ButtonLight>
              <Trans>Define your audience</Trans>
            </ButtonLight>
          )}
          {campaign.filters.length > 0 && (
            <div className="CampaignOverview__audience-summary">
              <div className="CampaignOverview__audience-icon">
                <IconPeople />
              </div>
              <span className="CampaignOverview__audience-description">
                <h2>
                  <Trans>Audience</Trans>
                </h2>
                {/* @ts-expect-error  9/11/2020*/}
                <HumanReadableFilters filters={campaign.filters} />
              </span>
            </div>
          )}
        </Link>
      </section>

      <section>
        <CampaignActions />
      </section>
    </div>
  )
}
